import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { postLike } from '@app-core/posts/actions'
import { compose, connect, withContext } from '@hocs'
import ArticleCard from '@components/ArticleCard'

class PlacePostContainer extends PureComponent {
  render() {
    if (!this.props.post) return null
    const post = this.props.post.toJS()
    return <ArticleCard className="masonry-article" article={post} isLoaded zoomIn={false} />
  }
}

const mapStateToProps = (state, ownProps) => {
  const { postId } = ownProps
  return {
    post: state.place.getIn(['posts', postId]),
  }
}

export default compose(
  connect(mapStateToProps, { postLike }),
  withContext(
    {
      postLike: PropTypes.func.isRequired,
    },
    ({ postLike }) => ({ postLike }),
  ),
)(PlacePostContainer)
